import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axios";

import "./ForgotPassword.css";

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError("Please enter your email");
      return;
    }

    try {
      setLoading(true);
      setError("");
      setSuccess("");

      const res = await api.post("/forget-password", {
        email,
      });

      setSuccess(res.data.message);

      // Redirect after 3 sec
      setTimeout(() => {
        navigate("/login");
      }, 3000);

    } catch (err) {
      setError(
        err.response?.data?.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
  <div className="forgot-wrapper">
    <img
      src="/images/kinexarL.svg"
      alt="KINEXAR"
      style={{ position: 'absolute', top: '40px', left: '50%', transform: 'translateX(-50%)', height: '32px' }}
    />
    <div className="forgot-card" style={{ marginTop: '60px' }}>

        {/* Icon */}
        <div className="forgot-icon">
          <svg viewBox="0 0 24 24">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>

        <h2>Forgot Password</h2>
        <p className="forgot-subtitle">
          Enter your email and we'll send you a new temporary password.
        </p>

        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={loading}
          >
            {loading ? "Sending..." : "Send New Password"}
          </button>
        </form>

        <div className="forgot-divider" />

        <p
          className="back-login"
          onClick={() => navigate("/login")}
        >
          Back to Login
        </p>

      </div>
    </div>
  );
};

export default ForgotPassword;